import { PrizesClickBuilder, TasksClickBuilder } from '../../builders'
import { BaseController } from '../base.controller/base.controller'

export class HeaderAnalytics extends BaseController {
  /**
   * Клик по кнопке "Задачи" в хедере
   */
  onTasksClick() {
    this.send(TasksClickBuilder, {})
  }

  /**
   * Клик по кнопке "Награды" в хедере
   */
  onPrizesClick() {
    this.send(PrizesClickBuilder, {})
  }
}
